export default "__VITE_ASSET__CLiPZjV3__"